(() => {
  const selectedKarat = (scope) => {
    const values = [
      ...Array.from(scope.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value),
      ...Array.from(scope.querySelectorAll('select')).map((select) => select.value)
    ];
    const match = values.join(' ').match(/\b(10K|14K|18K)\b/i);
    return match ? match[1].toUpperCase() : '';
  };

  const selectedMetal = (scope) => {
    const values = [
      ...Array.from(scope.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value),
      ...Array.from(scope.querySelectorAll('select')).map((select) => select.value)
    ];
    const match = values.join(' ').match(/\b(?:10K|14K|18K) (?:White|Yellow|Rose) Gold\b/i);
    return match ? match[0].replace(/\b(white|yellow|rose)\b/i, (value) => value[0].toUpperCase() + value.slice(1).toLowerCase()) : '';
  };

  const updateProcessing = (scope) => {
    const karat = selectedKarat(scope);
    const timing = karat === '14K'
      ? { headline: 'Ready to ship in approximately 2 business days.', range: 'approximately 2 business days' }
      : (karat === '10K' || karat === '18K'
        ? { headline: 'Ready to ship in approximately 7–10 business days.', range: 'approximately 7–10 business days' }
        : null);

    scope.querySelectorAll('[data-fere-processing-time]').forEach((panel) => {
      panel.hidden = timing === null;
      if (timing === null) return;
      const headline = panel.querySelector('[data-fere-processing-headline]');
      const support = panel.querySelector('[data-fere-processing-support]');
      if (headline) headline.textContent = timing.headline;
      if (support) support.textContent = 'After your specifications are confirmed. Carrier transit time is additional.';
    });
  };

  const updatePhotographyGuidance = (scope) => {
    const picker = scope.querySelector('variant-selects, variant-radios');
    if (!picker) return;

    const note = scope.querySelector('[data-fere-photography-guidance]');
    if (!note) return;

    const metal = selectedMetal(scope);
    if (!metal) {
      note.hidden = true;
      return;
    }

    note.hidden = false;
    const gallery = scope.querySelector('fere-ring-gallery');
    if (gallery?.dataset.photoReference === 'true') {
      const pictured = gallery.dataset.picturedColor;
      const picturedMetal = pictured[0].toUpperCase() + pictured.slice(1) + ' Gold';
      note.textContent = `Your selected metal is ${metal}. The reference photographs show this ring in ${picturedMetal}.`;
    } else if (gallery?.dataset.photoUnavailable === 'true') {
      note.textContent = `A matching photograph for your selected ${metal} is not available.`;
    } else if (gallery) {
      const metalChoices = [...gallery.querySelectorAll('[data-gallery-color]')].length;
      const faceButton = gallery.querySelector('[data-gallery-view="face"]');
      const flatButton = gallery.querySelector('[data-gallery-view="flat"]');
      const hasFace = Boolean(faceButton && !faceButton.hidden);
      const hasFlat = Boolean(flatButton && !flatButton.hidden);
      note.textContent = (metalChoices > 1 ? 'Choose an available gold color to see your ring in that metal. ' : 'Images show the listed metal. ') + (hasFace && hasFlat ? 'Select On model or On hand for a closer sense of proportion.' : hasFace ? 'Select On model for a closer sense of proportion.' : hasFlat ? 'Select On hand for a closer sense of proportion.' : 'Images are enlarged to show detail.');
    } else {
      note.textContent = 'Images are enlarged to show detail. Your ring will be made in the selected metal.';
    }
  };

  const init = (scope) => {
    if (!scope) return;
    updateProcessing(scope);
    updatePhotographyGuidance(scope);
    scope.addEventListener('change', () => window.requestAnimationFrame(() => {
      updateProcessing(scope);
      updatePhotographyGuidance(scope);
    }));
    scope.addEventListener('fere:gallery:render', () => updatePhotographyGuidance(scope));
  };

  document.querySelectorAll('product-info').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('product-info').forEach(init);
  });
})();

